'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var block = require('multiformats/block');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:repo:utils:walk-dag');

function walkDag(_x, _x2, _x3, _x4) {
  return _walkDag.apply(this, arguments);
}

function _walkDag() {
  _walkDag = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, blockstore, loadCodec, options) {
    var bytes, codec, block$1, _iterator, _step, _step$value, childCid;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _awaitAsyncGenerator(blockstore.get(cid, options));

          case 3:
            bytes = _context.sent;
            _context.next = 6;
            return _awaitAsyncGenerator(loadCodec(cid.code));

          case 6:
            codec = _context.sent;
            block$1 = block.createUnsafe({
              bytes: bytes,
              cid: cid,
              codec: codec
            });
            _iterator = _createForOfIteratorHelper(block$1.links());
            _context.prev = 9;

            _iterator.s();

          case 11:
            if ((_step = _iterator.n()).done) {
              _context.next = 18;
              break;
            }

            _step$value = _slicedToArray(_step.value, 2), childCid = _step$value[1];
            _context.next = 15;
            return childCid;

          case 15:
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(walkDag(childCid, blockstore, loadCodec, options)), _awaitAsyncGenerator), "t0", 16);

          case 16:
            _context.next = 11;
            break;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](9);

            _iterator.e(_context.t1);

          case 23:
            _context.prev = 23;

            _iterator.f();

            return _context.finish(23);

          case 26:
            _context.next = 32;
            break;

          case 28:
            _context.prev = 28;
            _context.t2 = _context["catch"](0);
            log('Could not walk DAG for CID', cid.toString(), _context.t2);
            throw _context.t2;

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 28], [9, 20, 23, 26]]);
  }));
  return _walkDag.apply(this, arguments);
}

exports.walkDag = walkDag;